<template>
  <div>
    <!-- <el-button-group>
      <el-button type="primary" size="small" plain @click="openUploadEvidence">上传佐证</el-button>
      <el-button type="primary" size="small" plain @click="openViewEvidence">查看佐证</el-button>
    </el-button-group> -->

    <el-dialog title="上传文件" :visible.sync="uploadDialogVisible" width="500px" append-to-body>
      <multiple-file-upload v-model="currentFiles" filePath="/qc/evidence" :limit="10" />

      <el-input v-model="remark" type="textarea" placeholder="备注" rows="3" class="remark-input" />

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="uploadDialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="handleUploadConfirm">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="查看佐证" :visible.sync="viewDialogVisible" width="1000px" append-to-body>
      <el-table :data="evidenceList" border size="small" v-loading="evidenceLoading">
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column label="文件名" prop="name"> </el-table-column>
        <el-table-column label="大小" width="100" align="center">
          <template slot-scope="{ row }">
            {{ row.fileSize | fileSizeFilter }}
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="200" show-overflow-tooltip />
        <el-table-column label="预览" width="260" align="center">
          <template slot-scope="{ row }">
            <file-preview :value="row.url" />
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="handleRemove(row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { getRouteResourceList, batchSaveQcResource, removeQcResource } from "@/api";

export default {
  name: "UploadEvidenceBtn",
  props: {
    routeId: {
      type: Number,
      required: true
    },
    driverId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      uploadDialogVisible: false,
      viewDialogVisible: false,
      remark: "",
      currentFiles: [],
      evidenceList: [],
      evidenceLoading: false
    };
  },
  methods: {
    openUploadEvidence() {
      this.uploadDialogVisible = true;
    },

    openViewEvidence() {
      this.viewDialogVisible = true;
      this.fetchEvidenceList();
    },

    handleUploadConfirm() {
      const files = this.currentFiles;
      const param = {
        files,
        remark: this.remark,
        routeId: this.routeId,
        driverId: this.driverId
      };
      batchSaveQcResource(param).then(() => {
        this.$message.success("保存成功");
        this.uploadDialogVisible = false;
        this.$emit("onResourceChanged");
      });
    },
    async fetchEvidenceList() {
      this.evidenceLoading = true;
      try {
        const res = await getRouteResourceList(this.routeId);
        this.evidenceList = (res && res.data) || [];
      } finally {
        this.evidenceLoading = false;
      }
    },

    handleRemove(id) {
      this.$confirm("确认删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        removeQcResource(id).then(() => {
          this.$emit("onResourceChanged");
          this.$message.success("删除成功");
          this.fetchEvidenceList();
        });
      });
    }
  }
};
</script>
<style lang="less" scoped>
.remark-input {
  margin-top: 10px;
}
</style>
